import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from '@getro/rombo';
import { Flex, Text } from 'rebass/styled-components';

const RemoveGoogleAccount = ({ isSubmitting, onCancel, onConfirm }) => (
  <Modal
    title="Remove Google account?"
    isOpen
    onCancel={onCancel}
    actions={
      <Flex justifyContent={['flex-end']}>
        <Button onClick={onCancel} variant="tertiary">
          Cancel
        </Button>
        <Button variant="danger" loading={isSubmitting} onClick={onConfirm}>
          Remove account
        </Button>
      </Flex>
    }
  >
    <Text width={1} mb={2} color="text.subtle">
      Removing this account will:
    </Text>
    <ul style={{ paddingLeft: '18px', marginTop: 0 }}>
      <li>
        <Text color="text.main">Stop syncing contacts</Text>
      </li>
      <li>
        <Text color="text.main">
          Remove all contacts from the networks they&apos;re being shared with (unless they&apos;ve been added in other
          ways)
        </Text>
      </li>
    </ul>
  </Modal>
);

RemoveGoogleAccount.propTypes = {
  isSubmitting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

RemoveGoogleAccount.defaultProps = {
  isSubmitting: false,
};

export default RemoveGoogleAccount;
